import { render, staticRenderFns } from "./SuspectedChart.vue?vue&type=template&id=6371b962&scoped=true&"
import script from "./SuspectedChart.vue?vue&type=script&lang=ts&"
export * from "./SuspectedChart.vue?vue&type=script&lang=ts&"
import style0 from "./SuspectedChart.vue?vue&type=style&index=0&id=6371b962&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6371b962",
  null
  
)

export default component.exports